import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Collapse, Dropdown } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import logos from '../../assets/images/nkblacklogo.png';
import { Link, withRouter } from 'react-router-dom'
import axios from 'axios'



const Sidebar1 = (data) => {
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
    const nodeMode = process.env.NODE_ENV
    if (nodeMode === 'development') {
        var baseUrl = beckendLocalApiUrl
    } else {
        baseUrl = beckendLiveApiUrl
    }

    const access_token = localStorage.getItem('token')
    const [menuState, setMenuState] = useState({});
    const location = useLocation();
    const [props, setprops] = useState('')
    const [udata, setudata] = useState('')

    const [loading, setLoading] = useState(false)


    const toggleMenuState = (menuKey) => {
        setMenuState((prevState) => {
            const newState = Object.keys(prevState).reduce(
                (acc, key) => ({ ...acc, [key]: false }),
                {}
            );
            return { ...newState, [menuKey]: !prevState[menuKey] };
        });
    };

    useEffect(() => {
        const onRouteChanged = () => {
            // Remove the line that resets the menu state
            // document.querySelector('#sidebar').classList.remove('active');
            // setMenuState({});


            const dropdownPaths = [
                { path: '/apps', state: 'appsMenuOpen' },
                { path: '/admin', state: 'adminMenu' },
                { path: '/agent', state: 'agentMenu' },
                { path: '/game', state: 'gameMenu' },
                { path: '/user', state: 'userMenu' },
                { path: '/agent', state: 'agentMenu' },
                { path: '/challenge', state: 'challengeMenu' },
                { path: '/transaction', state: 'transactionMenu' },
                { path: '/basic-ui', state: 'basicUiMenuOpen' },
                { path: '/form-elements', state: 'formElementsMenuOpen' },
                { path: '/tables', state: 'tablesMenuOpen' },
                { path: '/icons', state: 'iconsMenuOpen' },
                { path: '/charts', state: 'chartsMenuOpen' },
                { path: '/user-pages', state: 'userPagesMenuOpen' },
                { path: '/error-pages', state: 'errorPagesMenuOpen' },
                { path: '/Reports', state: 'reportsMenu' }, // Added by Team
            ];

            dropdownPaths.forEach((obj) => {
                if (isPathActive(obj.path)) {
                    setMenuState((prevState) => ({ ...prevState, [obj.state]: true }));
                }
            });
            // Ensure the current menu state is preserved

        };

        const isPathActive = (path) => location.pathname === path;

        onRouteChanged();

        const body = document.querySelector('body');
        const navItems = document.querySelectorAll('.sidebar .nav-item');
        navItems.forEach((el) => {
            const handleMouseOver = () => {
                if (body.classList.contains('sidebar-icon-only')) {
                    el.classList.add('hover-open');
                }
            };
            const handleMouseOut = () => {
                if (body.classList.contains('sidebar-icon-only')) {
                    el.classList.remove('hover-open');
                }
            };
            el.addEventListener('mouseover', handleMouseOver);
            el.addEventListener('mouseout', handleMouseOut);

            return () => {
                el.removeEventListener('mouseover', handleMouseOver);
                el.removeEventListener('mouseout', handleMouseOut);
            };
        });
    }, [location]);

    

    useEffect(() => {
        const meedata = localStorage.getItem("uData");
        const userData = JSON.parse(meedata);
        const ldata = localStorage.getItem("PData")
        const pdata = JSON.parse(ldata)
        setprops(pdata)
        setudata(userData)

    }, [access_token])



    const toggleOffcanvas = () => {
        const sidebar = document.querySelector('.sidebar-offcanvas');
        if (sidebar) {
            sidebar.classList.remove('active'); // Close the sidebar
        }
    };

    


    return (
        <nav className='sidebar sidebar-offcanvas' id='sidebar'>
            <div className='sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top'>
                <a className='brand-logo' href='/dashboard'>
                    <img src={logos} alt='logo' style={{ width: '67px ', marginLeft: '-40px' }} />
                </a>
                {/* <div className="font-weight-bold">
        <h3>ADMIN PANEL</h3>
      </div> */}
            </div>
            <div className='sidebar_fixed'>
                <ul className='nav'>
                    {props.dashboard && (

                        <li className='nav-item menu-items'   >
                            <Link className='nav-link' to='/dashboard' onClick={toggleOffcanvas}>
                                <span className='menu-icon'>
                                    <i className='mdi mdi-speedometer'></i>
                                </span>
                                <span className='menu-title'>
                                    <Trans>Dashboard</Trans>
                                </span>
                            </Link>
                        </li>
                    )}
                    {props.agentdashboard && props.usertype == "Agent" && (

                        <li className='nav-item menu-items'>
                            <Link className='nav-link' to='/dashboard/AgentDash' onClick={toggleOffcanvas}>
                                <span className='menu-icon'>
                                    <i className='mdi mdi-speedometer'></i>
                                </span>
                                <span className='menu-title'>
                                    <Trans>Agent Dashboard</Trans>
                                </span>
                            </Link>
                        </li>
                    )}


                    {(props.allAdmins ||
                        props.newAdmin ||
                        props.earnings ||
                        props.sitesettings ||
                        props.Gatewaysettings ||
                        props.addBankDetail
                    ) && (
                            <li className='nav-item menu-items'>
                                <div
                                    className={
                                        menuState.agent ? 'nav-link menu-expanded' : 'nav-link'
                                    }
                                    onClick={() => toggleMenuState('adminMenu')}
                                    data-toggle='collapse'
                                >
                                    <span className='menu-icon'>
                                        <i className='mdi mdi-account-star'></i>
                                    </span>
                                    <span className='menu-title'>
                                        <Trans>Admin Manager</Trans>
                                    </span>
                                    <i className='menu-arrow'></i>
                                </div>
                                <Collapse in={menuState.adminMenu}>
                                    <div>
                                        <ul className='nav flex-column sub-menu'>
                                            {props?.allAdmins && (
                                                <li className={`nav-item menu-items ${location.pathname === '/admin/alladmins' ? 'active' : ''}`}>

                                                    {' '}
                                                    <Link
                                                        className='nav-link'
                                                        to='/admin/alladmins'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>All Admins</Trans>
                                                    </Link>
                                                </li>
                                            )}


                                            {props.newAdmin && (
                                                <li className={`nav-item menu-items ${location.pathname === '/admin/addadmin' ? 'active' : ''}`}>

                                                    {' '}
                                                    <Link
                                                        className='nav-link'
                                                        to='/admin/addadmin'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Add New Admin</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                                {/* {props.allAdmins && (
                                                <li className={`nav-item menu-items ${location.pathname === '/admin/all-logs' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'
                                                        to='/admin/all-logs'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>All-Logs</Trans>
                                                    </Link>
                                                </li>
                                            )} */}
                                            {props.newAdmin && (
                                                <li className={`nav-item menu-items ${location.pathname === '/user/notification' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'
                                                        to='/user/notification'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Notification</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                        
                                            {props.earnings && (
                                                <li className={`nav-item menu-items ${location.pathname === '/earinigs' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'
                                                        to='/earinigs'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Admin Earing</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.sitesettings && (
                                                <li className={`nav-item menu-items ${location.pathname === '/admin/sitesettings' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'
                                                        to='/admin/sitesettings'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Website Settings</Trans>
                                                    </Link>
                                                </li>
                                            )}

                                            {props.Gatewaysettings && (
                                                <li className={`nav-item menu-items ${location.pathname === '/admin/getwaysettings' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'

                                                        to='/admin/getwaysettings'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Getway Settings</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {/* {props.addBankDetail && (
                                                <li className={`nav-item menu-items ${location.pathname === '/admin/Bankdetails' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'
                                                        to='/admin/Bankdetails'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>BankDetails</Trans>
                                                    </Link>
                                                </li>
                                            )} */}


                                        </ul>
                                    </div>
                                </Collapse>
                            </li>
                        )}
                    {(props.allAgent ||
                        props.agentWallet
                    ) && (
                            <li className='nav-item menu-items '>
                                <div
                                    className={
                                        menuState.agent ? 'nav-link menu-expanded' : 'nav-link'
                                    }
                                    onClick={() => toggleMenuState('agentMenu')}
                                    data-toggle='collapse'
                                >
                                    <span className='menu-icon'>
                                        <i className='mdi mdi-account-star'></i>
                                    </span>
                                    <span className='menu-title'>
                                        <Trans>Agent Manager</Trans>
                                    </span>
                                    <i className='menu-arrow'></i>
                                </div>
                                <Collapse in={menuState.agentMenu}>
                                    <div>
                                        <ul className='nav flex-column sub-menu'>

                                            {props.allAgent && (
                                                <>
                                                    <li className={`nav-item menu-items ${location.pathname === '/agent/allagents' ? 'active' : ''}`}>
                                                        {' '}
                                                        <Link
                                                            className='nav-link'
                                                            to='/agent/allagents'
                                                            onClick={toggleOffcanvas}
                                                        >
                                                            <span className='menu-icon'>
                                                                <i className='mdi mdi-arrow-right'></i>
                                                            </span>{' '}
                                                            <Trans>All Agent</Trans>
                                                        </Link>
                                                    </li>

                                                </>
                                            )}
                                            {
                                                props.agentWallet && (
                                                    <>
                                                        <li className={`nav-item menu-items ${location.pathname === '/agentWallet' ? 'active' : ''}`}>
                                                            {' '}
                                                            <Link
                                                                className='nav-link'
                                                                to='/agentWallet'
                                                                onClick={toggleOffcanvas}
                                                            >
                                                                <span className='menu-icon'>
                                                                    <i className='mdi mdi-arrow-right'></i>
                                                                </span>{' '}
                                                                <Trans>Agent Wallet</Trans>
                                                            </Link>
                                                        </li>

                                                    </>
                                                )}
                                            {
                                                props.agentWallet && (
                                                <>
                                                    <li className={`nav-item menu-items ${location.pathname === '/wallethistory' ? 'active' : ''}`}>
                                                        {' '}
                                                        <Link
                                                            className='nav-link'
                                                            to='/wallethistory'
                                                            onClick={toggleOffcanvas}
                                                        >
                                                            <span className='menu-icon'>
                                                                <i className='mdi mdi-arrow-right'></i>
                                                            </span>{' '}
                                                            <Trans>Wallet History</Trans>
                                                        </Link>
                                                    </li>

                                                </>
                                            )}



                                        </ul>
                                    </div>
                                </Collapse>
                            </li>
                        )}

                    {(props.allUsers ||
                        props.newUser ||
                        props.pendingKyc ||
                        props.completedKyc  ||
                        props.blockUser
                    ) && (
                            <li
                                className='nav-item menu-items'
                            >
                                <div
                                    className={
                                        menuState.userMenu ? 'nav-link menu-expanded' : 'nav-link'
                                    }
                                    onClick={() => toggleMenuState('userMenu')}
                                    data-toggle='collapse'
                                >
                                    <span className='menu-icon'>
                                        <i className='mdi mdi-face'></i>
                                    </span>
                                    <span className='menu-title'>
                                        <Trans>User Manager</Trans>
                                    </span>
                                    <i className='menu-arrow'></i>
                                </div>
                                <Collapse in={menuState.userMenu}>
                                    <div>
                                        <ul className='nav flex-column sub-menu'>
                                            {props.allUsers && (
                                                <li className={`nav-item menu-items ${location.pathname === '/user/allusers' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link

                                                        className='nav-link'
                                                        to='/user/allusers'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>View All Users</Trans>
                                                    </Link>
                                                </li>
                                            )}

{props.blockUser && (
                                                <li className={`nav-item menu-items ${location.pathname === '/Reports/blockuser' ? 'active' : ''}`}>
                                                    <Link
                                                        className='nav-link'
                                                        to='/Reports/blockuser'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Block User</Trans>
                                                    </Link>
                                                </li>
                                            )}

                                            {props.pendingKyc && (
                                                <li className={`nav-item menu-items ${location.pathname === '/user/UserKyc' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'
                                                        to='/user/UserKyc'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Pending Kyc</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.completedKyc && (
                                                <li className={`nav-item menu-items ${location.pathname === '/user/kyc' ? 'active' : ''}`}>
                                                    <Link
                                                        className='nav-link'
                                                        to='/user/kyc'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Completed Kyc</Trans>
                                                    </Link>
                                                </li>
                                            )}

                                            {props.rejectKyc && (
                                                <li className={`nav-item menu-items ${location.pathname === '/user/reject' ? 'active' : ''}`}>
                                                    <Link
                                                        className='nav-link'

                                                        to='/user/reject'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Reject Kyc</Trans>
                                                    </Link>
                                                </li>
                                            )}

                                        </ul>
                                    </div>
                                </Collapse>
                            </li>
                        )}


                    {(props.allChallenges ||
                        props.completedChallenges ||
                        props.conflictChallenges ||
                        props.cancelledChallenges ||
                        props.runningChallenges ||
                        props.pendingChallenges ||
                        props.newChallenge) && (
                            <li
                                className='nav-item menu-items'
                            >
                                <div
                                    className={
                                        menuState.challengeMenu ? 'nav-link menu-expanded' : 'nav-link'
                                    }

                                    onClick={() => toggleMenuState('challengeMenu')}
                                    data-toggle='collapse'
                                >
                                    <span className='menu-icon'>
                                        <i className='mdi mdi-xbox-controller'></i>
                                    </span>
                                    <span className='menu-title'>
                                        <Trans>Challenge Manager</Trans>
                                    </span>
                                    <i className='menu-arrow'></i>
                                </div>
                                <Collapse in={menuState.challengeMenu}>
                                    <div>
                                        <ul className='nav flex-column sub-menu'>
                                            {props.allChallenges && (
                                                <li className={`nav-item menu-items ${location.pathname === '/challenge/allchallenges' ? 'active' : ''}`}>
                                                    <Link
                                                        className='nav-link'

                                                        to='/challenge/allchallenges'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>View All Challenge</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.completedChallenges && (
                                                <li className={`nav-item menu-items ${location.pathname === '/challenge/completed_challange' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'

                                                        to='/challenge/completed_challange'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Completed Challenge</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.conflictChallenges && (
                                                <li className={`nav-item menu-items ${location.pathname === '/challenge/conflict_challange' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'

                                                        to='/challenge/conflict_challange'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Conflict Challenge</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {/* {props.conflictChallenges && (
                                                <li className={`nav-item menu-items ${location.pathname === '/all/challenge/conflict_challange' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'

                                                        to='/all/challenge/conflict_challange'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans> All Conflict Challenge</Trans>
                                                    </Link>
                                                </li>
                                            )} */}
                                            {props.cancelledChallenges && (
                                                <li className={`nav-item menu-items ${location.pathname === '/challenge/cancelled_challange' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'

                                                        to='/challenge/cancelled_challange'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Cancelled Challenge</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.pendingChallenges && (
                                                <li className={`nav-item menu-items ${location.pathname === '/challenge/pending_challange' ? 'active' : ''}`}>
                                                    <Link
                                                        className='nav-link'

                                                        to='/challenge/pending_challange'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Pending Challenge</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.runningChallenges && (
                                                <li className={`nav-item menu-items ${location.pathname === '/challenge/running_challange' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'

                                                        to='/challenge/running_challange'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Running Challenge</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.newChallenge && (
                                                <li className={`nav-item menu-items ${location.pathname === '/challenge/new_challange' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'

                                                        to='/challenge/new_challange'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>New Challenge</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </Collapse>
                            </li>
                        )}


                    {(props.penalty ||
                        props.bonus ||
                        props.bonusReport ||
                        props.penaltyReport ||
                        props.depositVerify ||
                        
                        props.manualDepositHistory ||
                        props.depositHistory ||
                        props.withdrawlHistory ||
                        props.withdrawVerify||
                        props.allWithdrawlRequests ||
                        props.allDepositRequests) && (
                            <li className='nav-item menu-items'>
                                <div
                                    className={
                                        menuState.transactionMenu ? 'nav-link menu-expanded' : 'nav-link'
                                    }
                                    onClick={() => toggleMenuState('transactionMenu')}
                                    data-toggle='collapse'
                                >
                                    <span className='menu-icon'>
                                        <i className='mdi mdi-transit-transfer'></i>
                                    </span>
                                    <span className='menu-title'>
                                        <Trans>Transaction Manager</Trans>
                                    </span>
                                    <i className='menu-arrow'></i>
                                </div>
                                <Collapse in={menuState.transactionMenu}>
                                    <div>
                                        <ul className='nav flex-column sub-menu'>
                                            {props.bonus && (
                                                <li className={`nav-item menu-items ${location.pathname === '/transaction/bonus' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'
                                                        to='/transaction/bonus'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Bonus</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.penalty && (
                                                <li className={`nav-item menu-items ${location.pathname === '/transaction/penalty' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'
                                                        to='/transaction/penalty'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Penalty</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.bonusReport && (
                                                <li className={`nav-item menu-items ${location.pathname === '/Reports/bonusReport' ? 'active' : ''}`}>

                                                    {' '}
                                                    <Link
                                                        className='nav-link'

                                                        to='/Reports/bonusReport'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Bonus History</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.penaltyReport && (
                                                <li className={`nav-item menu-items ${location.pathname === '/Reports/penaltyReport' ? 'active' : ''}`}>

                                                    {' '}
                                                    <Link
                                                        className='nav-link'

                                                        to='/Reports/penaltyReport'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Penalty History</Trans>
                                                    </Link>
                                                </li>
                                            )}

                                            {props.allDepositRequests && (
                                                <li className={`nav-item menu-items ${location.pathname === '/transaction/alldeposits' ? 'active' : ''}`}>
                                                    <Link
                                                        className='nav-link'
                                                        to='/transaction/alldeposits'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Pending deposits</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.depositHistory && (
                                                <li className={`nav-item menu-items ${location.pathname === '/transaction/reffer_redeem' ? 'active' : ''}`}>

                                                    {' '}
                                                    <Link
                                                        className='nav-link'
                                                        to='/transaction/reffer_redeem'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Reffer redeem</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.depositHistory && (
                                                <li className={`nav-item menu-items ${location.pathname === '/transaction/transaction_history' ? 'active' : ''}`}>

                                                    {' '}
                                                    <Link
                                                        className='nav-link'
                                                        to='/transaction/transaction_history'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Deposit history</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.depositVerify && (
                                                <li className={`nav-item menu-items ${location.pathname === '/transaction/depositVerify' ? 'active' : ''}`}>

                                                    <Link
                                                        className='nav-link'
                                                        to='/transaction/depositVerify'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Deposit verify</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.manualDepositHistory && (
                                                <li className={`nav-item menu-items ${location.pathname === '/transaction/deposit_manual' ? 'active' : ''}`}>

                                                    <Link
                                                        className='nav-link'
                                                        to='/transaction/deposit_manual'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Deposit Manual</Trans>
                                                    </Link>
                                                </li>
                                            )}

                                          
                                            {props.withdrawlHistory && (
                                                <li className={`nav-item menu-items ${location.pathname === '/transaction/withdraw' ? 'active' : ''}`}>
                                                    <Link
                                                        className='nav-link'
                                                        to='/transaction/withdraw'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Withdrawl history</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                              {props.withdrawVerify && (
                                                <li className={`nav-item menu-items ${location.pathname === '/transaction/withdrawVerify' ? 'active' : ''}`}>
                                                    <Link
                                                        className='nav-link'
                                                        to='/transaction/withdrawVerify'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>Withdrawl verify</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.allWithdrawlRequests && (
                                                <li className={`nav-item menu-items ${location.pathname === '/transaction/allwithdrawl' ? 'active' : ''}`}>
                                                    <Link
                                                        className='nav-link'
                                                        to='/transaction/allwithdrawl'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>View All Withdrawl Request</Trans>
                                                    </Link>
                                                </li>
                                            )}




                                        </ul>
                                    </div>
                                </Collapse>
                            </li>
                        )}

                    {(props.bonusReport ||
                        props.penaltyReport ||
                        props.depositReport ||
                        props.withdrawlReport) && (
                            <li
                                className='nav-item menu-items'
                            >
                                <div
                                    className={
                                        menuState.reportsMenu ? 'nav-link menu-expanded' : 'nav-link'
                                    }
                                    onClick={() => toggleMenuState('reportsMenu')}
                                    data-toggle='collapse'
                                >
                                    <span className='menu-icon'>
                                        <i className='mdi mdi-poll-box'></i>
                                    </span>
                                    <span className='menu-title'>
                                        <Trans>Reports</Trans>
                                    </span>
                                    <i className='menu-arrow'></i>
                                </div>
                                <Collapse in={menuState.reportsMenu}>
                                    <div>
                                        <ul className='nav flex-column sub-menu'>
                                            {props.bonusReport && (
                                                <li className={`nav-item menu-items ${location.pathname === '/Reports/bonusReport' ? 'active' : ''}`}>
                                                    {' '}
                                                    <Link
                                                        className='nav-link'

                                                        to='/Reports/bonusReport'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>bonus Report</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.penaltyReport && (
                                                <li className={`nav-item menu-items ${location.pathname === '/Reports/penaltyReport' ? 'active' : ''}`}>
                                                    <Link
                                                        className='nav-link'

                                                        to='/Reports/penaltyReport'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                          <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>penalty Report</Trans>
                                                    </Link>
                                                </li>
                                            )}
                                            {props.depositReport && (
                                                <li className={`nav-item menu-items ${location.pathname === '/Reports/depositReport' ? 'active' : ''}`}>

                                                    <Link
                                                        className='nav-link'
                                                        to='/Reports/depositReport'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>deposit Report</Trans>
                                                    </Link>
                                                </li>
                                            )}

                                            {props.withdrawlReport && (
                                                <li className={`nav-item menu-items ${location.pathname === '/Reports/withdrawalReport' ? 'active' : ''}`}>

                                                    <Link
                                                        className='nav-link'

                                                        to='/Reports/withdrawalReport'
                                                        onClick={toggleOffcanvas}
                                                    >
                                                        <span className='menu-icon'>
                                                            <i className='mdi mdi-arrow-right'></i>
                                                        </span>{' '}
                                                        <Trans>withdrawal Report</Trans>
                                                    </Link>
                                                </li>
                                            )}


                                       
                                        </ul>
                                    </div>
                                </Collapse>
                            </li>
                        )}

                </ul>
            </div>
        </nav>
    );
};

export default Sidebar1;
